<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-17",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 37,
      navigateType: 'CLICK_NEXT',
      content: {
        layout: 'layout_left',
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Menstrual problems.png'),
        mainTitle: 'Do you have any of the following symptoms in the weak before menstruation:',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Anxious',
            },{
              text: 'Breast tenderness',
            }
          ],[
            {
              text: 'Often feel tired and lack of sleep',
            },{
              text: 'Memory loss',
            }
          ],[
            {
              text: 'None of these',
              unique: true
            }
          ]
        ],
      }
    }
  },
  computed: {
    nextPage: function(){
      if(this.$store.state.qsData[21] && this.$store.state.qsData[21].answer.length>0){
        if(this.$store.state.qsData[21].answer.indexOf('Women\'s Health') !== -1){
          return '/questionnaire/section2/18'
        }else{
          return '/questionnaire/section3'
        }
      }else{
        return '/questionnaire/section3'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
